export const GET_OEMS_REQUEST = 'GET_OEMS_REQUEST';
export const GET_OEMS_SUCCESS = 'GET_OEMS_SUCCESS';
export const GET_OEMS_FAILURE = 'GET_OEMS_FAILURE';
